export default {
  "projectOrder.title": "添加标准品",
  "projectOrder.explain":
    "说明：衣柜产品请确定编组后再添加标准品，否则编组/解组操作可能导致标准品数据丢失",
  "projectOrder.showCaxa": "是否展示设计自带标准品",
  "projectOrder.caseName": "方案名称",
  "projectOrder.product": "组合柜",
  "projectOrder.productDetail": "标准品明细",
  "projectOrder.operate": "操作",
  "projectOrder.open": "是",
  "projectOrder.close": "否",
  "projectOrder.packageType": "套餐类型",
  "projectOrder.specifications": "规格",
  "projectOrder.productCode": "编码",
  "projectOrder.model": "型号",
  "projectOrder.classify": "分类",
  "projectOrder.details": "详情",
  "projectOrder.order": "(下单)",
  "projectOrder.notOrder": "(不下单)",
  "projectOrder.edit": "编辑",
  "projectOrder.designScheme": "(设计自带)",
  "projectOrder.parameters": "下单参数",
  "projectOrder.FaucetModel": "水龙头型号",
  "projectOrder.nonStandard": "是否非标",
  "projectOrder.installingBasin": "安装方式",
  "projectOrder.informationCenter": "本界面由欧派集团营销信息中心提供并负责",
  "projectOrder.createServiceOrder": "新建服务单",
  "projectOrder.rebind": "重新绑定",
  "projectOrder.fold": "收起",
  "projectOrder.unfold": "展开",
  "projectOrder.foldUnfold": "展开/收起",
  "projectOrder.more": "更多",
  "projectOrder.relatedOrder": "关联下单申请",
  "projectOrder.orderApplication": "下单申请号",
  "projectOrder.projectName": "项目名称",
  "projectOrder.projectBatch": "项目批次信息",
  "projectOrder.contractNumber": "合同编号",
  "projectOrder.buildingName": "楼盘名称",
  "projectOrder.brand": "品牌",
  "projectOrder.category": "品类",
  "projectOrder.totalNumberSets": "下单总套数",
  "projectOrder.serviceOrderNumber": "服务单号",
  "projectOrder.orderStatus": "服务单状态",
  "projectOrder.orderState": "订单状态",
  "projectOrder.houseType": "户型",
  "projectOrder.schemeNumber": "方案号",
  "projectOrder.creationTime": "创建时间",
  "projectOrder.supplementaryOrder": "是否补单",
  "projectOrder.details": "查看详情",
  "projectOrder.orderCategory": "订单类别",
  "projectOrder.designer": "设计师",
  "projectOrder.designerPhone": "设计师电话",
  "projectOrder.draftsman": "绘图师",
  "projectOrder.draftsmanPhone": "绘图师电话",
  "projectOrder.expectedDeliveryTime": "期望交期",
  "projectOrder.createStandards": "创建单独标准品订单",
  "projectOrder.myOrderTask": "我的下单任务",
  "projectOrder.customerInfo": "客户信息",
  "projectOrder.serviceOrder": "服务单",
  "projectOrder.productsOrdered": "下单产品",
  "projectOrder.orderInfos": "下单信息",
  "projectOrder.orderInfo": "订单信息",
  "projectOrder.attachments": "附件",
  "projectOrder.detailsExpress": "详情说明",
  "projectOrder.sceneFiles": "场景文件",
  "projectOrder.spaceProductName": "空间产品名",
  "projectOrder.afterSalesOrder": "是否遗留单",
  "projectOrder.productChannels": "产品渠道",
  "projectOrder.standardProducts": "标准品",
  "projectOrder.placeAnOrder": "下单",
  "projectOrder.doNotPlaceAnOrder": "不下单",
  "projectOrder.design": "设计",
  "projectOrder.specs": "规格",
  "projectOrder.model": "型号",
  "projectOrder.code": "编码",
  "projectOrder.productType": "产品类型",
  "projectOrder.details": "详情",
  "projectOrder.addStandardProducts": "添加标准品",
  "projectOrder.serviceOrderNumber": "服务单号",
  "projectOrder.noServiceOrderNumber": "无服务单号",
  "projectOrder.orderName": "合同自编号",
  "projectOrder.orderConsistent": "是否整单一致",
  "projectOrder.productCategory": "产品类别",
  "projectOrder.designSource": "设计来源",
  "projectOrder.approvalForm": "是否有线上审批",
  "projectOrder.assembled": "是否组装",
  "projectOrder.markType": "唛头类型",
  "projectOrder.assemblyMethod": "产品装配",
  "projectOrder.cartonRequirements": "纸箱要求",
  "projectOrder.logisticsMethods": "物流工艺",
  "projectOrder.displayRequirements": "摆样需求",
  "projectOrder.installationMethod": "水盆安装方式",
  "projectOrder.customerSupplied": "客供品配套",
  "projectOrder.projectInfo": "项目信息",
  "projectOrder.batchOrderQuantity": "批次下单数量",
  "projectOrder.remarks": "备注",
  "projectOrder.variableTable": "变量表",
  "projectOrder.view": "查看",
  "projectOrder.setup": "设置",
  "projectOrder.orderQuantity": "下单数量",
  "projectOrder.orderableQuantity": "可下单数量",
  "projectOrder.ordersPlacedNunmber": "本次下单数量",
  "projectOrder.upload": "上传",
  "projectOrder.splittingOrders": "拆单说明",
  "projectOrder.splitOrderSuccessful": "拆单成功",
  "projectOrder.splitOrderFailed": "拆单失败",
  "projectOrder.initiateInspection": "发起检查",
  "projectOrder.oneClickOrder": "一键下单",
  "projectOrder.refreshOrder": "刷新下单进度",
  "projectOrder.relatedOrderApplication": "关联下单申请",
  "projectOrder.buildingAbbreviation": "楼盘简称",
  "projectOrder.orderApplicationNo": "下单申请编号",
  "projectOrder.numberOfSetsOrdered": "下单套数",
  "projectOrder.search": "搜索",
  "projectOrder.addServiceOrder": "新增服务单",
  "projectOrder.option": "选项",
  "projectOrder.houseType": "户型",
  "projectOrder.schemeNo": "方案号",
  "projectOrder.orderQuantitys": "订单数",
  "projectOrder.engineerServiceOrder": "工程服务单",
  "projectOrder.batchSettings": "批量设置",
  "projectOrder.brandCategory": "所属品牌品类",
  "projectOrder.orderType": "订单类型",
  "projectOrder.EngineeringServiceNumber": "工程服务单号",
  "projectOrder.splitOrderDetails": "拆单详情",
  "projectOrder.initiateSplitOrder": "发起拆单",
  "projectOrder.option": "选项",
  "projectOrder.serialNumber": "序号",
  "projectOrder.placeOrderOrNot": "是否下单",
  "projectOrder.customerName": "客户姓名",
  "projectOrder.associateBefore": "请先关联下单申请再下单",
  "projectOrder.selectSceneFirst": "请先选择方案场景文件",
  "projectOrder.faucetCode": "水龙头编码",
  "projectOrder.deliveryTomorrow": "期望交期需选择明天以后",
  "projectOrder.basinInstallation": "水盆安装方式不能为空",
  "projectOrder.assembleEmpty": "是否组装不能为空",
  "projectOrder.quantityEmpty": "批次下单数量不能为空",
  "projectOrder.nonStandardApproval": "请选择非标审批单据",
  "projectOrder.serviceOrderIdEmpty": "服务单id不能为空，请选择其它服务单",
  "projectOrder.quantityOrderEmpty": "本次下单数量不能为0",
  "projectOrder.brandCategoryConsistent":
    "组合柜的品牌品类须和服务单品牌品类一致",
  "projectOrder.contractNumberInvalid": "所选服务单合同号无效,请更换服务单",
  "projectOrder.requiresSettingVariables": "非整单一致需要设置变量",
  "projectOrder.sourceEmpty": "设计来源不能为空",
  "projectOrder.variableEmpty":
    "未设置变量，需关联整单一致的服务单，请检查变量或服务单是否正确",
  "projectOrder.variableNotEmpty":
    "已设置变量，需关联非整单一致的服务单，请检查变量或服务单是否正确",
  "projectOrder.categoryEmpty": "产品类别不能为空",
  "projectOrder.expectedDeliveryEmpty": "期望交期不能为空",
  "projectOrder.spaceProductsEmpty": "空间产品不能为空",
  "projectOrder.associatedOrderEmpty": "关联工程服务单不能为空",
  "projectOrder.markTypeEmpty": "唛头类型不能为空",
  "projectOrder.assemblyEmpty": "产品装配不能为空",
  "projectOrder.cartonEmpty": "纸箱要求不能为空",
  "projectOrder.LogisticsProcessEmpty": "物流工艺不能为空",
  "projectOrder.sampleDisplayEmpty": "摆样需求不能为空",
  "projectOrder.customerSuppliesEmpty": "客供品配套不能为空",
  "projectOrder.selectedItemN":
    "本次下单数量不能为0，请先在变量设置中设置是否下单",
  "projectOrder.pleaseCheck": "请勾选订单明细",
  "projectOrder.orderIsRepeated":
    "关联的工程服务单出现重复，请修改关联不同的工程服务单进行下单！",
  "projectOrder.contractSelfNumber":
    "关联的工程服务单出现重复的合同自编号，请重新修改再下单",
  "projectOrder.sceneContentChanged": "场景内容发生改变，请确认下单信息",
  "projectOrder.retailOrdersSinks": "零售订单水槽不可下单盆，请选择套盆下单",
  "projectOrder.attachmentsModified": "下单后不能修改附件",
  "projectOrder.splitOrderNotCompleted": "拆单未完成，无法继续下单",
  "projectOrder.newInspection": "请重新发起检查拆单!",
  "projectOrder.caxaCounterTop": "请填写不使用CAXA台面图原因",
  "projectOrder.illegalCharacters1": "上传附件文件名包含非法字符",
  "projectOrder.illegalCharacters2": "请修正文件名重传",
  "projectOrder.notAllowXml": "一键下单不允许用户自行上传xml文件",
  "projectOrder.notAllowCountertop":
    "当前上传的文件命名中含有“台面”字样，如需上传台面文件请选择“台面附件”类型上传（卫浴台面图通过CAXA生成，不允许自行上传）。",
  "projectOrder.notCloseDesignFile":
    "设计软件拆单中，请勿关闭当前下单的设计方案文件，请稍后，当前已用时",
  "projectOrder.individualStandard": "单独标准品订单无需拆单，可直接下单",
  "projectOrder.successfullySubmitted":
    "提交拆单成功，可停留当前页面刷新拆单进度，也可关闭当前页面到下单任务中查看进度",
  "projectOrder.taskAlreadyHas":
    "当前下单任务已有拆单任务，本次操作将生成新的下单任务，请确认是否继续",
  "projectOrder.orderNotDetected":
    "工程服务单未检测到相关合同自编号,请重新选择有效工程服务单",
  "projectOrder.sceneNotVariables":
    "场景文件未设置变量，或数据返回异常请检查！",
  "projectOrder.serviceOrderAgain1":
    "该服务单未查询出遗留单合同号,无法下单,请重新选择服务单",
  "projectOrder.serviceOrderAgain2":
    "该服务单未查询出合同号,无法下单,请重新选择服务单",
  "projectOrder.canBePlaced":
    '服务单只有"未建单"、"建单成功"、"建单失败","设计文件处理中"、"设计文件处理成功"、"设计文件处理失败"状态下才可下单',
  "projectOrder.readingScene": "正在读取方案内容",
  "projectOrder.batchDownload": "批量下载拆单文件",
  "projectOrder.hasBeenSubmitted":
    "一键下单已提交，具体下单结果请到【我的下单任务】查看",
  "projectOrder.selectedItem": "所选项第",
  "projectOrder.and": "和",
  "projectOrder.name": "姓名",
  "projectOrder.accountNumber": "账号",
  "projectOrder.orderApplications": "请选择下单申请",
  "projectOrder.applicationInvalid": "所选下单申请无效/无服务单号",
  "projectOrder.applicationRelated": "关联工程下单申请完成",
  "projectOrder.non-standardMaterials":
    "有非标物料的审批时，产品类别请选择非标物料",
  "projectOrder.countertopAttachment":
    "注意：如需要上传台面相关附件，请选择“台面附件”类型上传",
  "projectOrder.notAllowedCad":
    "7月10日起，橱柜工程台面不允许CAD下单，如有疑问请从答疑平台咨询",
  "projectOrder.enterContractNumber": "请输入合同自编号",
  "projectOrder.variableSettings": "变量设置",
  "projectOrder.importVariable": "导入变量表",
  "projectOrder.exportVariable": "导出变量表",
  "projectOrder.orderOrNot": "是否下单",
  "projectOrder.clearVariable": "清空当前变量值",
  "projectOrder.reuseVariable": "复用历史变量值",
  "projectOrder.viewingVariable": "查看历史变量值",
  "projectOrder.resetVariable": "请重新设置变量",
  "projectOrder.displayOrderInformation": "关联下单申请后显示订单信息",
  "projectOrder.pleaseSelect": "请选择",
  "projectOrder.personnelList": "人员列表",
  "projectOrder.nameJobMobile": "姓名/工号/手机号",
  "projectOrder.option": "选项",
  "projectOrder.departmentStore": "部门/门店",
  "projectOrder.post": "岗位",
  "projectOrder.resignationOrNot": "是否离职",
  "projectOrder.total": "共",
  "projectOrder.page": "页",
  "projectOrder.goTo": "前往",
  "projectOrder.confirm": "确定",
  "projectOrder.searchContract": "搜索合同自编号、订单编号",
  "projectOrder.batchOrderPlacement": "批量传单",
  "projectOrder.numberOfSets": "套数",
  "projectOrder.projectBatchInformation": "项目批次信息",
  "projectOrder.factoryPlanned": "工厂计划交期",
  "projectOrder.administrativeDivision": "行政区划",
  "projectOrder.placeOrderNot": "是否传单",
  "projectOrder.FlyerTime": "传单时间",
  "projectOrder.specificAddress": "具体地址",
  "projectOrder.otherAttachments": "其他附件",
  "projectOrder.counterTopAttachments": "台面附件",
  "projectOrder.priceAttachments": "价格附件",
  "projectOrder.uploadAttachments": "上传附件",
  "projectOrder.counterTop": "台面",
  "projectOrder.selectAll": "全选",
  "projectOrder.startDate": "开始日期",
  "projectOrder.endDate": "结束日期",
  "projectOrder.to": "至",
  "projectOrder.selectBrand": "请选择品牌",
  "projectOrder.selectCategory": "请选择品类",
  "projectOrder.transferred": "转派给",
  "projectOrder.clickTransferred": "点击转派给",
  "projectOrder.oderUpdateTime": "订单更新时间",
  "projectOrder.noDataAvailable": "暂无数据",
  "projectOrder.loadingDesperately": "拼命加载中",
  "projectOrder.orderUpdateTime":
    "请根据订单更新时间确认所勾选的订单为最新下单信息",
  "projectOrder.successfullyPlaced": "传单成功",
  "projectOrder.defaultOrderType": "PTD-WMD-10-30-外贸单-普通单",
  "projectOrder.defaultOrderTypeGcd": "PTD-GCD-10-20-工程单-普通单",
  "projectOrder.enter": "请输入",
  "projectOrder.designerPhoneEmpty": "设计师电话不能为空",
  "projectOrder.designerEmpty": "设计师不能为空",
  "projectOrder.selectDate": "选择日期",
  "projectOrder.modifyingSpace":
    "修改空间产品名后无法覆盖已有订单，请确认订单是否已经上传，避免造成订单重复",
  "projectOrder.coverTabletop":
    "本次上传的台面图将覆盖设计软件拆单附件中的台面图，请确认是否替换？",

  "projectOrder.oppein": "欧派",
  "projectOrder.oboli": "欧铂丽",
  "projectOrder.oboni": "欧铂尼",
  "projectOrder.owell": "奥维",
  "projectOrder.baunis": "铂尼思",
  "projectOrder.starhomes": "STARHOMES",
  "projectOrder.oboladi": "欧铂拉迪",
  "projectOrder.fitzcarl": "菲思卡尔",
  "projectOrder.baunisStarhomes": "铂尼思Baunis",
  "projectOrder.miform": "miform",
  "projectOrder.outu": "欧图",
  "projectOrder.oppeinZhina": "欧派智纳",

  "projectOrder.youcai": "优材",
  "projectOrder.zhuangxiu": "装修",
  "projectOrder.zhucaijicheng": "主材集成",
  "projectOrder.zhuangjiamen": "装甲门",
  "projectOrder.bancai": "板材",
  "projectOrder.shangchu": "商橱",
  "projectOrder.jinshumenchuang": "金属门窗",
  "projectOrder.dajiaju": "大家居",
  "projectOrder.qiangshi": "软装",
  "projectOrder.mumen": "木门",
  "projectOrder.zhinengjiaju": "智能家居与照明",
  "projectOrder.weiyu": "卫浴",
  "projectOrder.obbao": "奥铂",
  "projectOrder.owell": "奥维",

  "projectOrder.wardrobe": "集成家居",
  "projectOrder.cabinet": "橱柜",
  "projectOrder.queuing": "排队中",
  "projectOrder.splittingOrders": "拆单中",
  "projectOrder.successfullySplit": "拆单成功",
  "projectOrder.splitOrderFailed": "拆单失败",
  "projectOrder.cancelSplit": "取消拆单",
  "projectOrder.simpleOrder": "简易拆单",
  "projectOrder.fullOrder": "全量拆单",
  "projectOrder.taskStatus": "请选择任务状态",
  "projectOrder.taskType": "请选择任务类型",
  "projectOrder.splitRecord": "请选择需要导出的拆单记录!",
  "projectOrder.splitNoFiles": "没有拆单成功的文件，请确认!",
  "projectOrder.cancelSplitSuccess": "取消拆单成功",
  "projectOrder.selectPersonnel": "请选择人员",
  "projectOrder.notCreated": "未建单",
  "projectOrder.creating": "建单中",
  "projectOrder.createdSuccessfully": "建单成功",
  "projectOrder.creationFailed": "建单失败",
  "projectOrder.designFileProcessing": "设计文件处理中",
  "projectOrder.successfullyDesignFiles": "设计文件处理成功",
  "projectOrder.designFileFailed": "设计文件处理失败",
  "projectOrder.draftSaved": "已保存草稿",
  "projectOrder.readingScheme": "正在读取方案内容",
  "projectOrder.uploadSuccessful": "上传成功",
  "projectOrder.batchSetBrand": "已批量设置相同品牌品类的产品类别",
  "projectOrder.enoppein": "OPPEIN",
  "projectOrder.importCompleted": "导入完成",
  "projectOrder.exporting": "正在导出,请稍等...",
  "projectOrder.deleteTask": "确定删除该下单任务?删除后任务记录不可见",
  "projectOrder.successfullyDeleted": "删除成功",
  "projectOrder.confirmation": "下单成功",
  "projectOrder.useCaxaTabletop": "请选择不使用CAXA台面图原因",
  "projectOrder.successfullyDeleted": "删除成功",
  "projectOrder.deleteOrder": "你确定要删除订单吗？",
  "projectOrder.makeSureStandard":
    "修改品牌、品类、产品渠道会清空标准品，请确认是否继续修改？",
  "projectOrder.quickLeaveOrder": "快速遗留单",
};



// WEBPACK FOOTER //
// ./src/locales/lang/zh-CN/projectOrder/settings.js